import React, { useId } from 'react';
import { useMenuIconAnimation } from './useMenuIconAnimation';
import './ProfileAnimatedIcon.css';

const ACTIVE_COLOR = '#3262FF';
const INACTIVE_COLOR = '#282932';

function ProfileAnimatedIcon({ color, isActive = false, size = 24 }) {
  const strokeColor = color || (isActive ? ACTIVE_COLOR : INACTIVE_COLOR);
  const clipId = useId();
  const { playing, handleClick } = useMenuIconAnimation(isActive, 1100);

  return (
    <span
      className={[
        'profile-animated-icon',
        playing ? 'profile-animated-icon--playing' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        '--profile-icon-fill': strokeColor,
        width: size,
        height: size,
      }}
      onClick={handleClick}
      role="presentation"
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style={{ color: strokeColor }}
      >
        <defs>
          <clipPath id={clipId}>
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>

        <g clipPath={`url(#${clipId})`}>
          <circle cx="12" cy="8" r="4" />

          <path d="M4 20C4 16.6863 7.58172 14 12 14C16.4183 14 20 16.6863 20 20V21H4V20Z" />
        </g>
      </svg>
    </span>
  );
}

export default ProfileAnimatedIcon;
